import { css, unsafeCSS } from 'lit';
import { color, rem, tint } from '../css.helper';
import { base } from './base.css';

export const OPTION_INPUT_SIZE = 24;

export const inputBaseStyles = css`
  :host([aria-disabled='true']) {
    cursor: not-allowed;
    opacity: 0.4;
  }

  :host([aria-disabled='true']:active) {
    pointer-events: none;
  }
`;

export const inputElementStyles = unsafeCSS(`
  font-family: inherit;
  color: inherit;
  font-size: ${rem(16)};
  border: ${rem(1)} solid;
  border-color: ${color('grey', 600)};
  border-radius: ${rem(4)};
  background-color: ${color('grey', 100)};
  padding: ${rem(12)};
`);

export const baseOptionStyles = css`
  :host {
    align-items: center;
  }

  :host([disabled]),
  :host([disabled='true']),
  :host([disabled]) *,
  :host([disabled='true']) * {
    cursor: not-allowed;
  }

  :where(label) {
    cursor: pointer;
    display: flex;
    gap: ${rem(12)};
  }

  ::slotted(tmwc-content-paragraph) {
    line-height: 1.5;
  }

  :where(input) {
    align-items: center;
    appearance: none;
    block-size: ${rem(OPTION_INPUT_SIZE)};
    border: ${rem(2)} solid;
    border-color: ${tint(300)};
    border-radius: ${rem(4)};
    cursor: pointer;
    display: flex;
    flex-shrink: 0;
    inline-size: ${rem(OPTION_INPUT_SIZE)};
    justify-content: center;
    margin: 0;
    padding: ${rem(4)};
    background-color: ${color('white')};
    transition:
      background var(--tm-transition-duration-normal)
        var(--tm-transition-function-ease-out),
      border var(--tm-transition-duration-normal)
        var(--tm-transition-function-ease-out),
      color var(--tm-transition-duration-normal)
        var(--tm-transition-function-ease-out);
  }

  :where(input):checked {
    background-color: ${color('blue')};
    border-color: ${color('blue')};

    &:disabled {
      background-color: ${color('grey', 400)};
      border-color: ${color('grey', 400)};
    }

    &:disabled + .icon {
      color: ${color('grey', 500)};
    }
  }

  @media (hover: hover) {
    :where(input):not([disabled]):hover {
      border-color: ${color('blue')};
    }
  }
`;

export const optionStyles = [base.focus, inputBaseStyles, baseOptionStyles];
